import * as React from 'react';
import type { AssetId } from 'owa-timestream-types';

export interface ViewStateSelectors {
    clearSelectedAssets: () => void;
    getSelectedAssetTypes: () => Map<string, number>;
    getZoom: () => number;
    isMovingAssets: () => boolean;
    isSelectedAsset: (assetId: AssetId) => boolean;
    selectAsset: (assetId: AssetId) => void;
    startDraggingAssets: () => void;
    toggleAssetSelection: (assetId: AssetId) => void;
    isAssetsLocked: () => boolean;
}

const defaultSelectors: ViewStateSelectors = {
    clearSelectedAssets: () => {},
    getSelectedAssetTypes: () => new Map(),
    getZoom: () => 1,
    isMovingAssets: () => false,
    isSelectedAsset: () => false,
    selectAsset: () => {},
    startDraggingAssets: () => {},
    toggleAssetSelection: () => {},
    isAssetsLocked: () => false,
};

const ViewStateSelectorsContext = React.createContext<ViewStateSelectors>(defaultSelectors);
ViewStateSelectorsContext.displayName = 'ViewStateSelectorsContextContext';

/**
 * This provider is used by the canvas to give assets a way to interact with the canvas view state.
 */
export const ViewStateSelectorsProvider = ViewStateSelectorsContext.Provider;

export function useViewStateSelectors() {
    return React.useContext(ViewStateSelectorsContext);
}
